export const getLanguage = (ietf) => ietf.split("-")[0];
